// extracted by mini-css-extract-plugin
module.exports = {"buttonLabelSm":"ShrinkingButtonGroup_buttonLabelSm__Nn0q4","popper":"ShrinkingButtonGroup_popper__3lqrM","buttonLabelLg":"ShrinkingButtonGroup_buttonLabelLg__3Idds"};